import { render } from "./CoachRegistration.vue?vue&type=template&id=3b82c0b0"
import script from "./CoachRegistration.vue?vue&type=script&lang=js"
export * from "./CoachRegistration.vue?vue&type=script&lang=js"
script.render = render

export default script